/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_hub_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`15% of 80 = (15 ÷ 100) × 80 = 12.`)
};

const es_pct_hub_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`15% de 80 = (15 ÷ 100) × 80 = 12.`)
};

const de_pct_hub_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`15 % von 80 = (15 ÷ 100) × 80 = 12.`)
};

const nl_pct_hub_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`15% van 80 = (15 ÷ 100) × 80 = 12.`)
};

const fr_pct_hub_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`15 % de 80 = (15 ÷ 100) × 80 = 12.`)
};

const it_pct_hub_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il 15% di 80 = (15 ÷ 100) × 80 = 12.`)
};

const pt_br2_pct_hub_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`15% de 80 = (15 ÷ 100) × 80 = 12.`)
};

const pt_pct_hub_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`15% de 80 = (15 ÷ 100) × 80 = 12.`)
};

const ja_pct_hub_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`80の15% = (15 ÷ 100) × 80 = 12。`)
};

const zh_pct_hub_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`80 的 15% = (15 ÷ 100) × 80 = 12。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_hub_ex1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_hub_ex1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_hub_ex1", locale)
	if (locale === "en") return en_pct_hub_ex1(inputs)
	if (locale === "es") return es_pct_hub_ex1(inputs)
	if (locale === "de") return de_pct_hub_ex1(inputs)
	if (locale === "nl") return nl_pct_hub_ex1(inputs)
	if (locale === "fr") return fr_pct_hub_ex1(inputs)
	if (locale === "it") return it_pct_hub_ex1(inputs)
	if (locale === "pt-BR") return pt_br2_pct_hub_ex1(inputs)
	if (locale === "pt") return pt_pct_hub_ex1(inputs)
	if (locale === "ja") return ja_pct_hub_ex1(inputs)
	return zh_pct_hub_ex1(inputs)
};